<template>
  <v-container fluid grid-list-md class="pa-7">
    <popup />
    <v-layout row wrap>
      <v-flex xs12>
        <dynamic-alert v-model="stationary">
          <template v-slot:error>
            Yasal zorunluluk gereğince TC Numaranızı doğrulamadan SMS gönderim
            aşamalarını test edemiyorsunuz.<br />
            Lütfen <a href="user/settings" style="color: #fff">buraya </a>
            tıklayarak vatandaşlık bilgilerinizi doğruladıktan sonra
            temsilcilerimizi hesabınızı test kullanımına açmaları için
            bilgilendiriniz.
          </template>
        </dynamic-alert>
        <v-layout row>
          <v-flex xs12>
            <div class="mb-4">
              <h2>Hoşgeldiniz</h2>
              <h3 class="font-weight-medium">
                {{ user.name }} {{ user.surname }} &nbsp; / &nbsp;{{
          user.company_name
        }}
              </h3>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row style="margin-bottom: 24px">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 sm6 md3>
                <card title="Müşteri Kodu" :data="`${$store.state.user.confirmation === '4' ? 'DEMO-' : ''
          }${data.user.id}`" class="customer-card">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                    stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </card>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <card title="Kredi" v-bind:data="data.accountDetails.credit" class="customer-credit">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                    stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </card>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="$store.state.user.id != 14821 && $store.state.user.id != 255458" >
                <card title="Whatsapp Kredi" v-bind:data="data.user.wp_credit" class="customer-whatsapp-credit">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                    stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </card>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <router-link to="/other-projects" style="text-decoration: none;">
                  <card title="Diğer Projelerimiz" class="customer-other-project">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"
                      class="main-grid-item-icon" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </card>
                </router-link>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="data.countdown.show">
                <card title="Kredi Kullanım Süresi" v-bind:data="`${data.countdown.remaining_day} gün`"
                  class="customer-license">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                    stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </card>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="slides" v-show="false">
                <v-card class="mx-auto">
                  <carousel :slides="slides" @change="(incomeCampaign) => {
          campaign.data = incomeCampaign;
        }
          " @tap="campaign.show = !campaign.show">
                    <template v-slot:item="{ slide }">
                      <card campaign="true">
                        <img :src="slide.image" :alt="slide.image" />
                      </card>
                    </template>
                  </carousel>
                  <v-dialog v-model="campaign.show" :max-width="450">
                    <v-card>
                      <v-card-title class="heading">{{
          campaign.data.title
        }}</v-card-title>
                      <v-card-text class="subtitle-1">{{
            campaign.data.description
          }}</v-card-text>
                    </v-card>
                  </v-dialog>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="user.parent_user_id === null && clock.active">
                <card campaign="true">
                  <v-layout row>
                    <v-flex xs4>
                      <v-sheet class="d-flex justify-center align-center" height="96" color="red darken-3">
                        <div class="font-weight-medium" style="color: white"
                          :class="{ title: $vuetify.breakpoint.xlOnly }">
                          {{ clock.hours }}:{{ clock.minutes }}:{{
          clock.seconds
        }}
                        </div>
                      </v-sheet>
                    </v-flex>
                    <v-flex xs8>
                      <v-sheet class="d-flex justify-center align-center" height="96" color="">
                        <div class="text-center">
                          Hesabınızı 24 Saat içerisinde aktif edin,
                          <div class="text-center">
                            Hediye <b>250 SMS</b> Kazanın!
                          </div>
                          <div class="text-center">
                            ( <b>Havale</b> ve <b>EFT</b> alımlarında. )
                          </div>
                        </div>
                      </v-sheet>
                    </v-flex>
                  </v-layout>
                </card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>



        <v-layout v-if="data.failedSmsJobs && data.failedSmsJobs.length > 0">
          <v-flex xs12>
            <v-lazy v-model="active" :options="{ threshold: 0.5 }" transition="fade-transition">
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-card>
                    <card-toolbar title="Beklemede Kalan Mesajlar"></card-toolbar>
                    <v-container fluid>
                      <v-alert prominent text type="error">
                        <v-row align="center">
                          <v-col class="grow">
                            Oluşan bir hatadan dolayı gönderilmeyen
                            SMS(ler)'iniz var.
                          </v-col>
                        </v-row>
                      </v-alert>
                      <v-data-table hide-default-footer :headers="headers" :items="data.failedSmsJobs">
                        <template v-slot:item.remainning_sms="{ item }">
                          {{ data.failedSmsJobs.length }} SMS
                        </template>
                        <template v-slot:item.delete="{ item }">
                          <v-btn class="error" v-on:click="cancel(item.id)">İptal Et</v-btn>
                        </template>
                        <template v-slot:item.send="{ item }">
                          <v-btn class="primary" v-on:click="reSend(item.id)">Tekrar Gönder</v-btn>
                        </template>
                      </v-data-table>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-lazy>
          </v-flex>
        </v-layout>
        <!-- Slider buraya eklenecek -->

        <v-layout>
          <v-flex xs12>
            <v-lazy v-model="active" :options="{ threshold: 0.5 }" transition="fade-transition">

              <v-layout row>
                <v-flex xs12 md6>
                  <number style="padding: 0" :standalone="false"></number>
                </v-flex>
                <v-flex md6 xs12>
                  <v-card>

                    <card-toolbar title="İlginizi Çekebilecek Diğer Projelerimiz"></card-toolbar>
                    <v-container fluid>
                      <dashboard-slider />

                    </v-container>
                  </v-card>
                  <br>
                  <v-card>

                    <card-toolbar title="Son Gönderilen Mesajlar(5)"></card-toolbar>
                    <v-container fluid>
                      <skeletal-loader type="list-item-avatar-three-line" v-if="data.last5message.length">
                        <v-expansion-panels>
                          <v-expansion-panel v-for="(item, k) in data.last5message" :key="k">
                            <v-expansion-panel-header style="user-select: text">{{ item.message }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-layout row>
                                <v-flex xs6 sm4>
                                  <div class="font-weight-medium subtitle-1">
                                    Gönderim Tarihi
                                  </div>
                                  <span class="body-2">{{
          item.created_at
        }}</span>
                                </v-flex>
                                <v-flex xs6 sm4>
                                  <div class="font-weight-medium subtitle-1">
                                    Gönderici Adı
                                  </div>
                                  <span class="body-2">{{ item.sender }}</span>
                                </v-flex>
                                <v-flex xs6 sm2>
                                  <div class="font-weight-medium subtitle-1">
                                    Başarılı
                                  </div>
                                  <span class="body-2">{{ item.success }}</span>
                                </v-flex>
                                <v-flex xs6 sm2>
                                  <div class="font-weight-medium subtitle-1">
                                    Başarısız
                                  </div>
                                  <span class="body-2">{{ item.fail }}</span>
                                </v-flex>
                              </v-layout>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </skeletal-loader>
                      <skeletal-loader type="list-item" v-else>
                        <div class="
                            display-1
                            text--accent-3 text-md-center
                            mx-auto
                          ">
                          Gösterilecek Sonuç Yok!
                        </div>
                      </skeletal-loader>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-lazy>
          </v-flex>
        </v-layout>
      </v-flex>
      <template v-if="data.notifications.length">
        <notifications-dialog v-for="(notification, i) in data.notifications" :key="i" :notification="notification"
          :max-width="450">
        </notifications-dialog>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import EventBus from '../../misc/eventbus';
import SkeletalLoader from '../Components/SkeletalLoader.vue';
import Number from './Sms/Number.vue';
import Card from '../Components/Card.vue';
import CardToolbar from '../Components/CardToolbar.vue';
import DynamicAlert from '../Components/DynamicAlert.vue';
import Carousel from '../Components/Carousel.vue';
import NotificationsDialog from '../Components/Pluggable/NotificationsDialog.vue';
import Popup from '@/views/Components/Reference/Popup';
import DashboardSlider from '@/views/Components/DashboardSlider.vue'; // Yeni bileşeni import ediyoruz
import Swal from 'sweetalert2'
import whatsappImg from '../../assets/whatsapp.png';

export default {
  name: 'home',
  components: {
    NotificationsDialog,
    Carousel,
    DynamicAlert,
    Card,
    CardToolbar,
    Number,
    SkeletalLoader,
    Popup,
    DashboardSlider // Yeni bileşeni buraya ekliyoruz
  },
  data: () => ({
    clock: {
      active: false,
      hours: '',
      minutes: '',
      seconds: '',
    },
    active: false,
    campaign: {
      show: false,
      data: {
        title: '',
        description: '',
        image: '',
      },
    },
    headers: [
      { text: 'Tarih', value: 'created_at' },
      { text: 'Mesaj', value: 'message' },
      { text: 'Hata Açıklaması', value: 'service_description' },
      { text: 'Kalan Gönderim Sayısı', value: 'remainning_sms' },
      { text: 'Son İşlem Tarihi', value: 'updated_at' },
      { text: ' ', value: 'delete' },
      { text: ' ', value: 'send' },
    ],
    data: {
      last5message: [],
      failedSmsJobs: [],
      user: {},
      countdown: {},
      notifications: [],
      accountDetails: {},
    },
    pagination: {
      current: 1,
      total: 0,
    },
    colors: [
      'orange',
      'warning',
      'pink darken-2',
      'red lighten-1',
      'deep-purple accent-4',
    ],
    slides: [],
  }),
  computed: {
    ...mapState(['user']),
    ...mapFields(['loading', 'notificationTimeout']),

    stationary() {
      const details = this.data.accountDetails;
      const { user } = this.data;
      return [
        {
          type: 'error',
          state: user.confirmation !== '1' && !user.id_number,
          id: 'error',
        },
        {
          type: 'warning',
          state: user.debt > 0,
          content: `Sayın ${user.name}, Güncel borcunuz: ${user.debt} TL`,
        },
        {
          type: 'warning',
          state: user.confirmation === '3',
          content: details.can_send_sms_description,
        },
      ];
    },
  },
  methods: {
    ...mapActions({ send: 'sendBackend', sendAsync: 'asyncSender' }),
    getZeroPad(n) {
      return (parseInt(n, 10) >= 10 ? '' : '0') + n;
    },
    onLoad() {
      this.send({ route: 'dashboard' })
        .then((res) => {
          this.data.failedSmsJobs = res.data.data.failedSmsJobs;
          this.data.accountDetails = res.data.data.accountDetails;
          this.data.last5message = res.data.data.last5message;
          this.data.notifications = res.data.data.notification_modals;
          this.data.countdown = res.data.data.countdown;
          this.data.user = res.data.data.user;
          this.slides = res.data.data.news;

          this.user.password_changed = res.data.data.user.password_changed;
        })
        .finally(() => {
          EventBus.$emit('setNotificationState');
        });
    },
    cancel(id) {
      this.notificationTimeout = 5000;
      this.send({
        route: 'sms/job/cancel',
        data: { id },
      }).then(() => {
        this.notificationTimeout = 3000;
        this.onLoad();
      });
    },
    reSend(id) {
      this.notificationTimeout = 5000;
      this.send({
        route: 'sms/job/resend',
        data: { id },
      }).then(() => {
        this.notificationTimeout = 3000;
        this.onLoad();
      });
    },
    countFailedSms(dataString) {
      return JSON.parse(dataString).length;
    },
    updateTime() {
      const endDate = new Date(this.user.quick_activation);
      const diffDate = new Date();
      const diff = endDate.getTime() - diffDate.getTime();

      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (this.user.quick_activation !== null) {
        this.clock = {
          active: true,
          hours: this.getZeroPad(hours),
          minutes: this.getZeroPad(minutes),
          seconds: this.getZeroPad(seconds),
        };
      } else {
        this.clock.active = false;
      }
    },
    async whatsappPopup() {
      this.sendAsync({ route: 'whatsapp/getpopup' })
        .then(async (res) => {
          if (res.data.status == 1) {
            this.showPopup();
          }
        });
    },
    showPopup() {
      const siteName = this.data.user.site === "toplusmspaketleri" ? "TOPLUSMS" : "VATANSMS";
      Swal.fire({
        title: `<img src="${whatsappImg}" style="margin-left:-80px;margin-right:30px;margin-bottom:-25px;width:60px;height:60px"></i><span style="color:#44bc2c">WHATSAPP</span><span style="margin-left:8px">${siteName}’te</span>`,
        html: `
        <p style="font-size:18px;margin-top:10px">Yoğun istek üzerine geliştirdiğimiz,<br>
          <b style="font-weight:bold">"<span style="color:#44bc2c">WHATSAPP</span> MESAJ GÖNDERME"</b> ekledik. <br> Aynı panel üzerinden mesajlarınızı ister SMS isterseniz de <span style="color:#44bc2c">Whatsapp</span>’tan yollayın.<br>
          • Çok ekonomiktir: 2000 karakter sadece 1 Mesaj,<br>
          • Kayıtsız numaralara, Excel veya Kopyala/Yapıştır ile Binlerce kişiye anında yollayın.<br>
          • Yabancı veya Türk numarası fark etmeden her cep telefonuna mesaj gönderin.<br>
          • Resim veya PDF dosyası yollayın.<br>
          • ${siteName} rehberinizi kullanacaksınız, ayrıca grup vs oluşturmaya gerek yok.<br>
          • Herkese özel tek mesaj gider. Gönderdiğiniz mesajı başkaları görmez<br><br>
          Bilgilendirme, Duyuru, Resimli ve PDF dosyası ekli mesaj yollayın. Bu <b style="font-weight:bold">FİYAT ve PERFORMANS</b> özelliği tam size göre!
        </p>
          <button id="showFormPopup" class="w-100"style="font-size:16px;font-weight: bold;background-color: #28eb40;border-color:#28eb40;color:#fff;padding:1em;margin-top: 1rem;">
            Detaylar için temsilcim beni arasın
          </button>
          <button id="closePopup" class="btn w-100 text-gray" style="font-size:16px;font-weight: bold;background-color: #fff;border:1px solid gray;padding:1em;margin: 1rem 0 1rem 0;">
            Evet ama şu anda biraz işim var
          </button>
        <div class="form-check position-relative custom-checkbox mt-3 d-flex justify-content-center" style="padding: 0 30px;">
          <input id="popupCheckbox" type="checkbox" class="form-check-input custom-control-input d-block ml-5" style="cursor: pointer">
          <label class="form-check-label text-gray custom-control-label" style="font-size: 16px;cursor: pointer" for="popupCheckbox"><b>Bu mesajı bir daha gösterme</b></label>
        </div>
        `,
        showConfirmButton: false,
        width: '600px',
        didOpen: () => {
          document.getElementById('showFormPopup').addEventListener('click', this.showFormPopup);
          document.getElementById('closePopup').addEventListener('click', this.closePopup);
        },
        willClose: () => {
          document.getElementById('showFormPopup').removeEventListener('click', this.showFormPopup);
          document.getElementById('closePopup').removeEventListener('click', this.closePopup);
        }
      }).then((result) => {
      })
    },
    closePopup() {
      const isChecked = document.getElementById('popupCheckbox').checked;
      if (isChecked) {
        this.sendAsync({ route: 'whatsapp/dontshowpopup' });
      }
      Swal.close();
    },
    showFormPopup() {
      Swal.fire({
        title: 'Whatsapp Aktivasyon Talebi Formu',
        html: `
        <div class="form-group text-left">
            <label style="font-weight: bold;font-size: 16px;margin-bottom: 6px;">Bilgileriniz:</label>
            <input class="swal2-input mt-0" id="read_info_name" placeholder="Adınız Soyadınız">
            <input class="swal2-input mt-0" maxlength="11" id="read_info_phone" placeholder="Telefon (05320000000)">
        </div>
           `,
        confirmButtonText: 'Formu Gönder',
      }).then((result) => {
        if (result.value) {
          var veriler = {};
          veriler.name = document.getElementById("read_info_name").value;
          veriler.phone = document.getElementById("read_info_phone").value;
          if (veriler.name != "" && veriler.phone.length >= 10) {
            this.sendAsync({ route: 'whatsapp/form', data: veriler })
              .then(async (res) => {
                if (res.data == "ok") {
                  Swal.fire(
                    'İlginiz için Teşekkür Ederiz!',
                    'Talebiniz tarafımıza ulaşmıştır, Müşteri temsilciniz en kısa sürede size ulaşacaktır.',
                    'success'
                  )
                }
              });
          } else {
            Swal.fire({
              title: 'Hata',
              type: 'error',
              text: 'Bütün Alanları Eksiksiz Doldurunuz.'
            }).then(() => {
              this.showFormPopup();
            })
          }
        }
      });
    }
  },
  created() {
    setInterval(this.updateTime, 1000);
    this.onLoad();
    this.send({ route: 'campaigns/show' }).then((res) => {
      this.slides = res.data.data;
    });

    const scriptGTM = document.createElement('script');
    scriptGTM.innerText = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W22DMV');";

    const scriptGTMNoScript = document.createElement('noscript');
    const noScriptFrame = document.createElement('iframe');
    noScriptFrame.src = 'https://www.googletagmanager.com/ns.html?id=GTM-W22DMV';
    noScriptFrame.height = '0';
    noScriptFrame.width = '0';
    noScriptFrame.style = 'display:none;visibility:hidden';

    scriptGTMNoScript.appendChild(noScriptFrame);

    document.head.appendChild(scriptGTM);
    document.body.prepend(scriptGTMNoScript);
    this.whatsappPopup();
  },
};
</script>

<style scoped>
.v-time-picker-clock__container {
  display: none !important;
}

.customer-card {
  background-image: radial-gradient(circle 1017px at 1.4% 22.8%,
      rgba(97, 76, 141, 1) 31.9%,
      rgba(242, 110, 98, 1) 90%);
}

.customer-credit {
  background-image: radial-gradient(circle 814px at 19.1% 53.8%,
      rgba(255, 165, 0, 1) 32.5%,
      rgba(50, 205, 50, 1) 100.2%);
}

.customer-license {
  background-image: radial-gradient(circle 814px at 19.1% 53.8%,
      rgba(255, 106, 38, 0.78) 32.5%,
      rgba(50, 205, 50, 1) 100.2%);
}

.company-card {
  background-color: rgb(255, 171, 0);
}
</style>
